module.exports = __webpack_public_path__ + "static/media/roble_cal.00679e02.jpg";